import * as constants from '../constants';

export default function (state = [], action) {
  switch (action.type) {
    case constants.GET_SPARKS_SUCCESS:
      return Object.assign({}, state, {
        sparks: action.sparks.data || [],
        isRefreshRequired: false,
      });
    case constants.POST_SPARK_SUCCESS:
      return Object.assign({}, state, {
        newSparkId: action.spark.data,
        isRefreshRequired: true,
      });
    case constants.PATCH_SPARK_SUCCESS:
    case constants.PUT_ADDITIONAL_FUNS_SUCCESS:
      return Object.assign({}, state, {
        isRefreshRequired: true,
      });
    case constants.CREATE_NEW_SPARK_SUCCESS:
    case constants.GET_SPARK_SUCCESS:
      return Object.assign({}, state, {
        spark: action.spark.data || {},
        isRefreshRequired: false,
      });
    case constants.GET_SPARKS_ERROR:
    case constants.GET_SPARK_ERROR:
    case constants.POST_SPARK_ERROR:
    case constants.PATCH_SPARK_ERROR:
    case constants.PUT_ADDITIONAL_FUNS_ERROR:
      return Object.assign({}, state, { error: action.error });
    default:
      return state;
  }
}
